import { Check } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';
import { cn } from '@/lib/utils';
import { useStepper } from './stepper-provider';

const StepHorizontalTrackBar = () => {
  const { currentStep, completedSteps, goToStep, getSteps } = useStepper();

  return (
    <div className="flex w-full flex-row flex-wrap justify-between">
      {getSteps().map((step) => {
        const isCompleted = completedSteps.includes(step.id);
        const isCurrent = currentStep === step.id;

        return (
          <div
            className={cn(
              "relative flex items-center after:h-0.5 after:border-t after:border-gray-500 after:bg-gray-300 after:content-[''] [&:not(:last-child)]:flex-1 [&:not(:last-child)]:after:mx-8 [&:not(:last-child)]:after:flex-1",
              isCompleted && 'after:border-gray-700 after:bg-gray-700'
            )}
            key={step.id}
          >
            <div className="flex items-center gap-2">
              <Button
                type="button"
                variant="ghost"
                className={cn(
                  'h-8 w-8 rounded-full border p-0 text-lg font-bold text-gray-300',
                  (isCurrent || isCompleted) && 'border-gray-700 text-foreground'
                )}
                onClick={() => goToStep(step.id)}
              >
                {isCompleted ? <Check size={18} /> : step.id}
              </Button>
              <div className="hidden md:block">{step.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StepHorizontalTrackBar;
